import dayjs from 'dayjs';
import i18next from 'i18next';
import * as yup from 'yup';
import { isFirstAfterSecond, isSame } from '../../../utils/dateCalculations';

export const schoolEventSchema = yup
  .object()
  .shape({
    subjectUuid: yup.string().required(i18next.t('validation.common.required')),

    name: yup
      .string()
      .required(i18next.t('validation.common.required'))
      .max(20, i18next.t('validation.common.maxLength', { length: 20 })),

    startDate: yup.date().required(),
    endDate: yup.date().required(),
  })
  .test('date-validation', '', function (values) {
    const errors: any = {};

    // Prüfung ob startDate nach endDate liegt
    if (isFirstAfterSecond(values.startDate, values.endDate, 'day')) {
      errors.startDate = i18next.t('validation.common.startDateAfterEnd');
      errors.endDate = i18next.t('validation.common.startDateAfterEnd');
    }

    // Prüfung ob am selben Tag startTime nach endTime liegt
    if (
      isSame(values.startDate, values.endDate, 'day') &&
      isFirstAfterSecond(values.startDate, values.endDate, 'minute')
    ) {
      errors.startDate = i18next.t('validation.common.startTimeAfterEnd');
      errors.endDate = i18next.t('validation.common.startTimeAfterEnd');
    }

    if (Object.keys(errors).length > 0) {
      return this.createError({
        path: Object.keys(errors)[0],
        message: Object.values(errors)[0] as string,
      });
    }

    return true;
  });
